<pds-form [formGroup]="form">
  <pds-form-row grid="1-1-2">
    <pds-form-field label="Canal de Venda">
      <input type="text" formControlName="clientId" />
    </pds-form-field>
    <pds-form-field label="Placa">
      <input type="text" formControlName="plate" />
    </pds-form-field>
    <pds-form-field label="Com Resultados">
      <select formControlName="withResult">
        <option value="">Todos</option>
        <option value="false">Sem resultados</option>
        <option value="true">Com resultados</option>
      </select>
    </pds-form-field>
    <pds-form-field label="Período">
      <pds-range-form formControlName="range" />
    </pds-form-field>
  </pds-form-row>
  <pds-form-actions>
    <button pdsButton (click)="onClickSearch()">Buscar</button>
  </pds-form-actions>
</pds-form>
